// extracted by mini-css-extract-plugin
module.exports = {"pdf__viewer":"PdfViewer_pdf__viewer__LKRJw","pdf__viewer--loaded":"PdfViewer_pdf__viewer--loaded___9eHP"};